export function nurseAndDeviceSerialsMatch(nurseDeviceSerial: string | undefined, fileDeviceSerial: string): boolean {
  if (nurseDeviceSerial === undefined) {
    return true;
  }

  nurseDeviceSerial = nurseDeviceSerial.trim();

  nurseDeviceSerial = removeManufacturerPrefix(nurseDeviceSerial);

  return nurseDeviceSerial === fileDeviceSerial;
}

function removeManufacturerPrefix(nurseDeviceSerial: string) {
  if (nurseDeviceSerial.toLowerCase().startsWith("toe")) {
    nurseDeviceSerial = nurseDeviceSerial.substring(3);
  }
  return nurseDeviceSerial;
}
